import { SET_NEXT_URL, SET_ROUTE_REDUCER } from "../types/routeTypes";

export const setNextUrl = (url) => {
  return (dispatch) => {
    dispatch({ type: SET_NEXT_URL, url: url });
  };
};

export const setRouteReducer = (data) => {
  return (dispatch) => {
    dispatch({ type: SET_ROUTE_REDUCER, payload: data });
  };
};
